import React, { useContext, useEffect, useState } from "react";
import ApiConfig from "../../api/ApiConfig";
import { useLoaderData, useLocation } from "react-router-dom";
import { GetWithAuth, simpleGetCallWithErrorResponse } from "../../api/ApiServices";
import { AppContext } from "../../context/AppContext";
import PetShopDetails from "./PetShopDetails";

const CategoryList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [category_item, set_category_item ] = useState(location.state.category_item || {}) ;
  // const { MenuCategoryList} = location.state|| {} ;
  // const [category_id, set_category_id] = useState(queryParams.get("category"));
  const [category_id, set_category_id] = useState(Number(localStorage.getItem("category_id")) || null);
  const [menuClick, setMenuClick] = useState(false);


  const { selectedStore, setMenuCategoryList,MenuCategoryList,subscribeToEvent } = useContext(AppContext);

  const [isLoadinAddToCart, setIsLoadinAddToCart] = useState(true);
  const [menuList, setMenuList] = useState([]);
  const [categoryName, setCategoryName] = useState(JSON.parse(localStorage.getItem('category_name')) || '');

  const handleCategoryChange = (id, name) => {
      localStorage.setItem('category_id', JSON.stringify(id))
      localStorage.setItem('category_name', JSON.stringify(name))
      setCategoryName(name)
    set_category_id(id);

    const temp =categoryItem(id, MenuCategoryList);
    
    set_category_item(temp);
    setMenuClick(false);
  }

const categoryItem = (cat_id, MenuCategoryList ) => {
    console.log ('cat---', cat_id , MenuCategoryList)
    let item = {};
    item = MenuCategoryList?.filter((item) => item.category_id == cat_id);
    console.log('item--', item)
    return item[0]
}
  const loadMenu = async () => {
    try {
      console.log(
        "url==>",
        `${ApiConfig?.GET_MENU}?restaurant_id=${selectedStore}&page_limit=9999&category=${Number(localStorage.getItem("category_id")) || null}`
      );
      let res = await GetWithAuth(
        `${ApiConfig?.GET_MENU}?restaurant_id=${selectedStore}&page_limit=9999&category=${Number(localStorage.getItem("category_id")) || null}`
      );
      setIsLoadinAddToCart(true);
      if (res?.success) {
        setMenuList([...res?.data]);
        // setMenuList([...res?.data,...res?.data,...res?.data,...res?.data,...res?.data,...res?.data])
      } else {
        setMenuList([]);
      }
    } catch (error) {
      setIsLoadinAddToCart(true);
         setMenuList([]);
    //   AlertDialogDanger(error?.message);
    }
  };

  const loadData = async () => {
    await loadMenu();
  };
  useEffect(()=>{
 loadData();
  },[category_id])

   const loadMenuCategory = async () => {
    try {
      let res = await simpleGetCallWithErrorResponse(
        `${ApiConfig?.GET_MENU_CATEGORY}?restaurant_id=${selectedStore}`
      );

   
      if (res?.json.success) {
        // console.log("GET_MENU_CATEGORY",res)
setMenuCategoryList(res?.json.data || []);
    
      } else {
        setMenuCategoryList([])
      }
    } catch (error) {
      // AlertDialogDanger(error?.message);
      setMenuCategoryList([])
    }
  };

  useEffect(()=>{
loadMenuCategory();
  },[selectedStore])

   const delay = 1500 + Math.random() * 1000; // 1.5s–2.5s
 
  useEffect(() => {
     if (!selectedStore) return;
   let timeoutId;
     const eventName = `${selectedStore}/updated-menu`;
 
     const unsubscribe = subscribeToEvent(eventName, (data) => {
       console.log("Menu updated:", data);
 
       // 🔥 Call your APIs
     timeoutId = setTimeout(() => {
  loadData()
 }, delay);
     });
 
     return () => {
       if (timeoutId) {
       clearTimeout(timeoutId);
     }
       unsubscribe();
     };
   }, [subscribeToEvent, selectedStore]);

  return (
<>
<PetShopDetails categoryName={categoryName} setMenuList={setMenuList} category_id={category_id} onListItemClick={handleCategoryChange} menuList={menuList}  category_item={category_item} MenuCategoryList={MenuCategoryList}  menuClick={menuClick} setMenuClick={setMenuClick}/>
 </>

  )
  
  
  
  
  
};

export default CategoryList;
